import { render, staticRenderFns } from "./SignupCompletePage.vue?vue&type=template&id=b420d500"
import script from "./SignupCompletePage.vue?vue&type=script&lang=ts"
export * from "./SignupCompletePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports